const {h, render, Component} = require('preact');
const SupportAPIHelper = require('../../../support/frontend/helpers/API')
const FlexibleMain = require('../views/flexible_main')
const EmailFormMainContainer = require('../../../web_2018/frontend/components/containers/email_form/email_form')

class FlexibleFormUS extends Component {
  constructor(props) {
    super(props);
  }

  getApiTimeout() {
    return Groupon.Utils.getConfigFromDom().flexibleApiTimeout
  }

  fetchHelpContent() {
    let urls = this.getHelpContentPaths()
    let data = this.getTaglines()
    let get_flexible_content_api_timeout_in_milliseconds = this.getApiTimeout() || 60000
    let errorCb = (response) => {
      this.setState(null)
    }
    let successCb = (response) => {
      if (response) {
        this.setState({'flexibleObjects': response, 'responseReceived': true})
      }
    }
    SupportAPIHelper.parallel(urls, data, successCb, false, null, get_flexible_content_api_timeout_in_milliseconds)
  }

  getHelpContentPaths() {
    let url = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/fetch?should_display_cms_content=true`
    return [url]
  }

  getTaglines() {
    let keyValue = `${this.getCategoryId()},${this.getSubCategoryId()}`
    return [{key: keyValue, base: "helpwizard_email_form", type: "flexible_step_three"}]
  }

  getCategoryId() {
    return this.props.contactChannelParams.dropdownCategory
  }

  getSubCategoryId() {
    return this.props.contactChannelParams.dropdownSubcategory
  }

  componentDidMount() {
    this.fetchHelpContent()
  }

  render() {
    var FormObject = this.state.flexibleObjects && this.state.flexibleObjects[0] != null ? FlexibleMain : EmailFormMainContainer
    if (this.state.responseReceived) {
      return (
        <FormObject handleCallUsLink = {this.props.handleCallUsLink} contactChannelParams={this.props.contactChannelParams} flexibleObjects={this.state.flexibleObjects}
                    handleClick={this.props.handleClick} resetState={this.props.resetState} guestOrder= {this.props.guestOrder} contactChannelConfig={this.props.contactChannelConfig}/>
      )
    }
  }
}

module.exports = FlexibleFormUS
